import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { colFormRef } from './consts';

export default grapesjs.plugins.add('gjs-subscriber-form', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'subscriber-form',
    blocks: [colFormRef],
    defaultStyle: true,
    labelForm: 'Subscriber Form',
    labelColFormCategory: 'Forms',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }

  loadComponents(editor, options);
  loadBlocks(editor, options);
});
